class PhiRedirect extends HTMLElement {
  constructor() {
    super();
    this.url = this.getAttribute('url');
    this.delay = parseInt(this.getAttribute('delay') || '0', 10);
  }

  connectedCallback() {
    if (!this.url) {
      console.warn('phi--redirect: No URL specified');
      return;
    }

    // Validate URL
    try {
      new URL(this.url);
    } catch (e) {
      // If relative URL, make it absolute
      if (this.url.startsWith('/')) {
        this.url = window.location.origin + this.url;
      } else {
        console.warn('phi--redirect: Invalid URL', this.url);
        return;
      }
    }

    // Perform redirect after delay
    if (this.delay > 0) {
      setTimeout(() => {
        window.location.href = this.url;
      }, this.delay);
    } else {
      window.location.href = this.url;
    }
  }
}

customElements.define('phi--redirect', PhiRedirect);

